import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { success } from 'assets/images';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function UploadVideoForm() {
	const navigate = useNavigate();
	const formik = useFormik({
		initialValues: {
			fullName: '',
			email: '',
			topic: '',
			video: null,
		},
		validationSchema: Yup.object({
			fullName: Yup.string()
				.min(3, 'Must be 3 characters or more')
				.required('Required'),
			email: Yup.string().email('Invalid email address').required('Required'),
			topic: Yup.string()
				.min(3, 'Must be 3 characters or more')
				.required('Required'),
			video: Yup.mixed().required('Video file is required'),
		}),
		onSubmit: () => {
			axios({
				method: 'POST',
				url: 'http://localhost:5000/api/form/shareYourStoryForm',
				data: formik.values,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
				.then(function (response) {
					console.log(response);
					Swal.fire({
						imageUrl: success,
						imageWidth: 100,
						imageHeight: 100,
						imageAlt: 'Success',
						title: 'Submitted Successfully',
						text: 'You have successfully filled the Upload a Video Form.',
						width: 600,
						color: '#fff',
						padding: '3em',
						background: '#000',
						confirmButtonColor: '#800080',
						backdrop: 'rgba(255,255,255,0.3)',
					});
					navigate('/');
				})
				.catch(function () {
					Swal.fire({
						imageUrl: success,
						imageWidth: 100,
						imageHeight: 100,
						imageAlt: 'Success',
						title: 'Submission was Unsuccessful',
						text: 'Kindly try again.',
						width: 600,
						color: '#fff',
						padding: '3em',
						background: '#000',
						confirmButtonColor: '#800080',
						backdrop: 'rgba(255,255,255,0.3)',
					});
				});
		},
	});

	return (
		<>
			<h1 className='text-3xl text-center font-semibold text-transparent bg-clip-text bg-gradient-to-b from-purple to-gold pb-6 pt-4'>
				Share Your Story
			</h1>
			<form
				onSubmit={formik.handleSubmit}
				className='border-2 border-solid border-[#C52EC8] p-8 mb-10'
			>
				<div className='mb-4'>
					<label htmlFor='fullName' className='text-black text-base'>
						Full Name <b className='text-red'>*</b>
					</label>
					<input
						name='fullName'
						type='text'
						className='w-full p-2 border-2 border-[#C52EC8] rounded'
						placeholder='Enter your full name'
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						value={formik.values.fullName}
					/>
					{formik.touched.fullName && formik.errors.fullName ? (
						<div className='text-red text-sm'>{formik.errors.fullName}</div>
					) : null}
				</div>
				<div className='mb-4'>
					<label htmlFor='email' className='text-black text-base'>
						Email Address <b className='text-red'>*</b>
					</label>
					<input
						name='email'
						type='email'
						className='w-full p-2 border-2 border-[#C52EC8] rounded'
						placeholder='Enter your email address'
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						value={formik.values.email}
					/>
					{formik.touched.email && formik.errors.email ? (
						<div className='text-red text-sm'>{formik.errors.email}</div>
					) : null}
				</div>

				{/* Topic */}
				<div className='mb-4'>
					<label htmlFor='topic' className='text-black text-base'>
						Topic <b className='text-red'>*</b>
					</label>
					<input
						name='topic'
						type='text'
						className='w-full p-2 border-2 border-[#C52EC8] rounded'
						placeholder='Enter your topic title'
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						value={formik.values.topic}
					/>
					{formik.touched.topic && formik.errors.topic ? (
						<div className='text-red text-sm'>{formik.errors.topic}</div>
					) : null}
				</div>

				{/* Video Upload */}
				<div className='mb-4'>
					<label htmlFor='video' className='text-black text-base'>
						Upload a Video (Maximum 100MB) <b className='text-red'>*</b>
					</label>
					<input
						type='file'
						name='video'
						className='block w-full p-2 border-2 border-[#C52EC8] rounded'
						accept='video/*'
						onChange={(event) => {
							formik.setFieldValue('video', event.currentTarget.files[0]);
						}}
					/>
					{formik.touched.video && formik.errors.video ? (
						<div className='text-red text-sm'>{formik.errors.video}</div>
					) : null}
				</div>

				{/* Submit Button */}
				<div className='flex justify-center'>
					<button
						type='submit'
						className='w-32 h-12 bg-purple text-white rounded hover:bg-purple-700'
					>
						Submit Video
					</button>
				</div>
			</form>
		</>
	);
}

export default UploadVideoForm;
